import React from 'react';
import { Container } from 'react-bootstrap';
import ExitReasonQuestion from '../../components/ExitReasonQuestion';
import styles from './index.module.scss';

// The standalone page at /goodbye, linked from our cancellation reply and from the
// 30 day renewal notice.
//
// It sits outside the signed-in part of the app on purpose: a studio reaching this page
// has already cancelled, so asking it to log in to answer one question would lose most
// of the answers. It is routed beside /documents/termsAndConditions in App.jsx, which is
// the app's existing pattern for a page that renders whether or not anyone is signed in.
const Goodbye = () => (
    <div className={styles.goodbye}>
        <Container>
            <ExitReasonQuestion variant="goodbye" />
        </Container>
    </div>
);

export default Goodbye;
